import { Box } from '@mui/material'
import SchemaTable from '../table/SchemaTable'
import FormattedDate from '../table/FormattedDate'
import { NOTHING } from './resolveReplyRows'

function DateCell({ value }) {
    if (value === NOTHING || value == null) {
        return <Box component="span">{NOTHING}</Box>
    }

    return <FormattedDate value={value} />
}

const announcementColumn = {
    Header: 'מודעה',
    accessor: 'announcementTitle',
}

const subjectColumn = {
    Header: 'נושא',
    accessor: 'subject',
}

const fromColumn = {
    Header: 'מאת',
    accessor: 'fromAddress',
}

const receivedAtColumn = {
    Header: 'תאריך תגובה',
    accessor: 'receivedAt',
    width: '11rem',
    Cell: (cell) => <DateCell value={cell.row.original.receivedAt} />,
}

const sentAtColumn = {
    Header: 'תאריך שליחה',
    accessor: 'sentAt',
    width: '11rem',
    Cell: (cell) => <DateCell value={cell.row.original.sentAt} />,
}

const columns = [
    announcementColumn,
    subjectColumn,
    fromColumn,
    receivedAtColumn,
    sentAtColumn,
]

export default function RepliesTable({ rows, onOpen }) {
    return (
        <SchemaTable
            data={rows ?? []}
            columns={columns}
            onRowClick={(event, clicked) => onOpen?.(clicked.original)}
        />
    )
}
